<div class="row mt-4 mb-2" [formGroup]="form">
  <div class="col-auto pt-2">
    Всего: <b>{{count}}</b>
  </div>
  <div class="col-auto">
    <app-material-input-checkbox
      [formControlName]="'complex'"
      [withMb0]="true"
    >Только ЖК</app-material-input-checkbox>
  </div>
  <div class="col-auto">
    <app-material-input-checkbox
      [formControlName]="'flat'"
      [withMb0]="true"
    >Только квартиры</app-material-input-checkbox>
  </div>
</div>
<div class="material-datatable-wrapper">
  <div class="table-responsive">
    <table class="table">
      <tr>
        @for (el of head; track el) {
          <th [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
            <div [formGroup]="form">
              <div class="row no-gutters align-items-center flex-nowrap" [ngStyle]="{'width': (el.width) ? el.width : 'auto'}">
                <div class="col table__input">
                  @if (el.input) {
                    <app-material-input
                      [placeholder] = "el.caption"
                      [formControlName] = "el.name"
                      [cssClass]="'mb-0'">
                    </app-material-input>
                  }
                  @if (el.select) {
                    <app-material-select
                      [formControlName]="el.name"
                      [cssClass]="'mb-0'">
                      <option [value]="''">{{el.caption}}</option>
                      @for (opt of el.select; track opt) {
                        <option [value]="opt.id">{{opt.caption}}</option>
                      }
                    </app-material-select>
                  }
                  @if (!el.input && !el.select) {
                    {{el.caption}}
                  }
                </div>
                @if (el.sort) {
                  <div class="col-auto">
                    <a href="javascript:void(0)" (click)="sortChange(el.name)">
                  <i class="icon" [ngClass]="{'icon_new-sort-none': true == !sort[el.name],
                                      'icon_new-sort-down': 'asc' == sort[el.name],
                                      'icon_new-sort-up': 'desc' == sort[el.name]}"></i>
                    </a>
                  </div>
                }
              </div>
            </div>
          </th>
        }
      </tr>
      <!-- // -->
      @for (row of rows; track row; let row_index = $index) {
        <tr>
          <td>{{row['date_time']}}</td>
          <td>{{row['visible_status'] ? 'Опубликовано' : 'Снято с публ.'}}</td>
          <td>
            <a [routerLink]="[realty_link_dict[row['realty_type']], row['realty_id']]">{{row['realty_caption']}}</a>
          </td>
          <td>
            <a [routerLink]="[realty_link_dict[row['realty_type']], row['realty_id']]">{{row['developer_caption']}}</a>
          </td>
          <td>{{module_source_dict[row['module_source']]}}</td>
          <td>
            @if (row['author_id']) {
              <a [routerLink]="['/physical/edit', row['author_id'], 'common']">{{row['author_fio']}}</a>
            }
            @if (!row['author_id']) {
              -
            }
          </td>
        </tr>
      }
    </table>
  </div>
</div>

<div class="alt-pagination">
  <app-paginator
    [queryParams]="filter_columns"
    [itemsPerPage]="50"
    [itemCount]="count"
    [currentPage]="current_page"
    [baseUrl]="'/realty-show-logs'">
  </app-paginator>
</div>
